import React, {useState} from "react";
import {useApiCreateStudentPaymentGenerate} from "@/api/payment";
import {urlPath} from "@/lib/utils/url";
import ApiHandleSuccessMessage, {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";
import {Alert, Button} from "antd";
import {toFaNumberFormat} from "@/lib/utils/number";

function LowBudgetAlertPay({budget}) {

    const [navigating, setNavigating] = useState(false)
    const {mutate: StartPayment, isPending} = useApiCreateStudentPaymentGenerate();

    function handleSubmit() {

        StartPayment({
            amount: budget * -1,
            callback_url: urlPath(),
            pay_type: 'online',
            subtype: 'full_pay_debt',

        }, {
            onSuccess: data => {
                ApiHandleSuccessMessage(data)
                if (data?.data?.data?.redirect_url) {
                    setNavigating(true)
                    window.location.href = data?.data?.data?.redirect_url;
                }

            },
            onError: error => {
                ApiHandleErrorMessage(error);
            }
        })
    }

    if (!budget || budget > 0) {
        return null
    } else {
        return (<>
            <Alert
                title="هشدار!"
                className={'mb-2'}
                showIcon
                description={
                    <>

                        شارژ حساب کاربری شما منفی شده است و پرونده شما شامل

                        <b className={'mx-2'}>
                            {toFaNumberFormat(budget * -1)}
                        </b>


                        تومان بدهی است.
                        <br/>
                        لطفا جهت جلوگیری از مسدود شدن حساب کاربری خود نسبت به پرداخت بدهی اقدام نمایید

                    </>
                }
                type="error"
                action={
                    <Button size="large"
                            loading={isPending || navigating}
                            color={'primary'} variant={'solid'} onClick={handleSubmit}>
                        پرداخت بدهی
                    </Button>
                }
            />
        </>)
    }
}

export default LowBudgetAlertPay